/** GOT: Samples from QC, the Acknowledge (docs/designs/got-web-acknowledge.md). Backed by /api/v1/got/handover/*. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { GotReceivePage } from "@/features/got/components/handover-got-page";

// Old links (?tab=sent / received) land on the Acknowledge tabs they became.
const search = z.object({
  tab: z
    .enum([
      "scanned",
      "to_receive",
      "sent_centres",
      "in_transit",
      "ok",
      "damaged",
      "sent",
      "received",
    ])
    .default("scanned")
    .transform((t) =>
      t === "sent" ? "to_receive" : t === "received" ? "ok" : t
    ),
  // SRF-wise view: an SRF no., or "none".
  srf: z.string().optional(),
});

export const Route = createFileRoute("/_app/quality/got/handover/receive")({
  validateSearch: search,
  // The hub (Receive & send) or a GOT centre (Acknowledge).
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("got.handover_receive") && !can("got.receipt"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected } = useFacilities();
  return (
    <GotReceivePage
      search={s}
      facilityId={selected?.id ?? null}
      plantName={selected ? selected.name : null}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
